import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	background: ${palette('schoolBabyBlue')};
	background-position: top center;
	background-repeat: no-repeat;
	background-size: cover;
	margin: 0 auto;
	max-width: 1440px;
	padding-bottom: 80px;
	position: relative;
	text-align: center;
`;

export const Heading = styled.h1`
	display: inline-block;
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 70px;
	position: relative;
	text-align: center;
	z-index: 0;

	&:after {
		background-image: url('/_n/images/schools/flourish-circle.webp');
		background-repeat: no-repeat;
		background-size: contain;
		content: '';
		display: none;
		left: -7%;
		position: absolute;
		top: 12%;
		height: 80px;
		width: 220px;
		z-index: -1;

		${minWidth('tablet')} {
			display: block;
		}
	}
`;
